export enum BusinessServiceRequestStatusesEnum {
  New = 0,
  Pending = 1,
  InProgress = 2,
  Completed = 3
}

